import {put,takeLatest  } from 'redux-saga/effects';
import NetworkHandler from '../net/NetworkHandler'
import {GET_GFS,GET_GF,GET_GPLACES} from '../containers/constants';
import { error ,success } from '../components/Alert/actions';
import {updateCryodexLinks} from '../containers/Home/actions';
import {updateFriends} from '../containers/Home/actions';


function* getFs(action){

    const Network = new NetworkHandler();
  
    try{
      const response = yield Network.getFs(action);	 
	
      if (!(response instanceof Error)) {
			
			localStorage.setItem("gFs", JSON.stringify(response));
			
        } else {
          yield put(
            error({
              message: `Unable to get cryodex links. ${response}`,
            })
          );
        }
    }catch (errorMsg) {
        yield put(
            error({
             message: `Unable to get cryodex links, please try again.${errorMsg}`,
            })
        );
    }

}

function* getF(action){

    const Network = new NetworkHandler();
  
    try{
      const response = yield Network.getF(action);	 
	 
      if (!(response instanceof Error)) {
		
		localStorage.setItem("gF", JSON.stringify(response));
        } else {
          yield put(
            error({
              message: `Unable to process request. ${response}`,
            })
          );
        }
    }catch (errorMsg) {
        yield put(
            error({
             message: `Unable to process request, please try again.${errorMsg}`,
            })
        );
    }

}

function* getPlaces(action){

    const Network = new NetworkHandler();
  
    try{
		
      const response = yield Network.getPlaces(action);	 
	
      if (!(response instanceof Error)) {			
			localStorage.setItem("gPlaces", JSON.stringify(response));
        } else {
          yield put(
            error({
              message: `Unable to get cryodex links. ${response}`,
            })
          );
        }
		
    }catch (errorMsg) {
        yield put(
            error({
             message: `Unable to get cryodex links, please try again.${errorMsg}`,
            })
        );
    }

}

export default function* gFriendsSagas() {
  yield takeLatest(GET_GFS, getFs);
  yield takeLatest(GET_GF,getF);
  yield takeLatest(GET_GPLACES,getPlaces);
}

